import { types, isType } from "mobx-state-tree"

export const Team = types.model({
    _id: types.identifier,
    bytes32Id: types.string,
    name: types.string,
    category: types.string,
    league: types.string,
    logoUrl: types.string,
    abbreviation: types.optional(types.string,"AAA"),
    colors: types.optional(types.array(types.string), ["rgb(0,0,0)", "rgb(255,255,255"]),
    apiId: types.optional(types.string, "")
});


// WEBPACK FOOTER //
// ./src/models/Team.js